export const CREATE_TRACKERS_QUERY_INPUT_MIN_FONT_SIZE: number = 48;

export const CREATE_TRACKERS_QUERY_INPUT_DEFAULT_FONT_SIZE: number = 60;

export const CREATE_TRACKERS_QUERY_INPUT_DEFAULT_HEIGHT: number =
  CREATE_TRACKERS_QUERY_INPUT_DEFAULT_FONT_SIZE * 1.22;

export const CREATE_TRACKERS_QUERY_INPUT_LIMIT: number = 150;
